import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

export const FinalCTA = () => (
  <section className="relative z-10 py-24 lg:py-40 px-4 overflow-hidden" data-testid="final-cta-section">
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none" aria-hidden="true">
      <motion.img
        src="/mascot.jpg"
        alt=""
        initial={{ opacity: 0, scale: 0.7 }}
        whileInView={{ opacity: 0.22, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
        className="w-[80vw] max-w-[720px] rounded-full animate-pumpkin blur-[2px]"
      />
      <div className="absolute w-[70vw] max-w-[640px] aspect-square rounded-full bg-[#FF6B00]/15 blur-3xl animate-flicker" />
    </div>

    <div className="relative max-w-4xl mx-auto text-center">
      <Reveal>
        <h2 className="font-display font-bold uppercase text-4xl sm:text-6xl lg:text-7xl leading-tight" data-testid="final-cta-line-1">
          <span className="glitch text-white" data-text="HALLOWEEN COMES ONCE A YEAR.">
            HALLOWEEN COMES <span className="text-[#FF6B00] glow-orange">ONCE A YEAR.</span>
          </span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p
          className="font-display font-bold uppercase text-2xl sm:text-4xl lg:text-5xl mt-6 text-[#B6FF00] glow-green"
          data-testid="final-cta-line-2"
        >
          BUT THE MEMES LIVE FOREVER.
        </p>
      </Reveal>
      <Reveal delay={0.35}>
        <a
          href="https://x.com/i/communities/1972316257106997599"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-join-button"
          className="inline-block mt-12 bg-[#B6FF00] text-black font-display font-bold uppercase text-xl sm:text-2xl tracking-wider px-12 py-6 rounded-full shadow-[0_0_35px_rgba(182,255,0,0.6)] hover:bg-[#c8ff3d] hover:scale-110 hover:shadow-[0_0_60px_rgba(182,255,0,0.95)] active:scale-95 transition-all duration-200"
        >
          JOIN $HALLOWIN
        </a>
      </Reveal>
    </div>
  </section>
);
